import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import {
  needsOnboardingAgreement,
  ONBOARDING_AGREEMENT_PATH,
} from "utils/roleHelpers";

const PublicRoute = () => {
  const { token, userType, userData } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!token) {
    return <Outlet />;
  }

  // Authenticated - check if they're in auth flow
  const authFlowPaths = [
    `${AUTH_PREFIX_PATH}/otp-input`,
    `${AUTH_PREFIX_PATH}/forget-email-otp-input`,
    `${AUTH_PREFIX_PATH}/new-password`,
    `${AUTH_PREFIX_PATH}/profile-setup`,
    `${AUTH_PREFIX_PATH}/business-profile-setup`,
    `${AUTH_PREFIX_PATH}/account-success`,
    `${AUTH_PREFIX_PATH}/subscription-plan`,
    `${AUTH_PREFIX_PATH}/account-activate`,
    ONBOARDING_AGREEMENT_PATH,
  ];

  if (authFlowPaths.includes(location.pathname)) {
    return <Outlet />;
  }

  const needsVerification =
    userType === "truck_owner" || userType === "fleet_manager";
  const isVerified = userData?.verified || false;

  if (needsVerification && !isVerified) {
    return <Navigate to={`${AUTH_PREFIX_PATH}/otp-input`} replace />;
  }

  // Verified carrier who hasn't signed the onboarding agreement yet — gate it
  // before any dashboard (mirrors the app's AppNavigator gate). Must come AFTER
  // verification: an unverified user always does OTP first, then the agreement.
  if (isVerified && needsOnboardingAgreement(userData)) {
    return <Navigate to={ONBOARDING_AGREEMENT_PATH} replace />;
  }

  // Redirect to role-specific dashboard
  const dashboardMap = {
    truck_owner: `${APP_PREFIX_PATH}/truck_owner/home`,
    mechanic: `${APP_PREFIX_PATH}/mechanic/dashboard`,
    fleet_manager: `${APP_PREFIX_PATH}/fleet-dashboard/home`,
    driver: `${APP_PREFIX_PATH}/driver/home`,
  };

  const redirectTo =
    dashboardMap[userType] || `${APP_PREFIX_PATH}/fleet-dashboard/home`;

  return <Navigate to={redirectTo} replace />;
};

export default PublicRoute;
